import { ProductType } from './../models/product.model';
import { ID } from '../models/ID.model';
import { CustomForm, CustomFormField, CustomFormType, CustomFormAnswer } from './../models/custom-form.model';
import { UtilsService } from './utils.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Document } from '../models/document.model';

@Injectable({
  providedIn: 'root'
})
export class FormsService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService
    ) { }

    requestForm(campos: CustomFormField[], mensaje: string, destinatario: string, idProducto: ID, tipoProducto: ProductType, tipo: CustomFormType, obligatorio: boolean) {
        return this.http.post<CustomForm>(`/formularios`, { campos, mensaje, destinatario, idProducto, tipo, obligatorio, tipoProducto });
    }

    getFormById(id: ID) {
        return this.http.get<CustomForm>(`/formularios/${id}`);
    }

    cancelForm(id: ID) {
        return this.http.post<CustomForm>(`/formularios/${id}/cancelacion`, {});
    }

    closeForm(id: ID, respuestas: CustomFormAnswer[]) {
        return this.http.post<CustomForm>(`/formularios/${id}/cierre`, { respuestas });
    }

    resendForm(id: ID) {
        return this.http.post(`/formularios/${id}/reenvio`, {});
    }

    uploadDocument(formId: ID, file: File, fieldId: ID) {
        return this.utilsService.uploadFile<Document>(
            file,
            `/formularios/${ formId }/documentos/url`,
            `/formularios/${ formId }/documentos/confirmacion`,
            {},
            {},
            { 'id-campo': String(fieldId) }
        );
    }
}
